<h1 mat-dialog-title>{{ 'Action Information' | translate }}</h1>
<div class="d-flex justify-content-between">
  <p>{{ data?.message }}</p>
</div>
<div mat-dialog-actions class="d-flex justify-content-between align-items-center flex-column">
  <button mat-raised-button color="primary" (click)="dialogRef.close(true)">
    {{ 'Close' | translate }}
  </button>
</div>
